<template>
  <z-form ref="form" autocomplete="on" @submit.native.prevent="sign_in">
    <z-form-group>
      <z-form-input :rules="{ email: true, required: true }" name="Email" mode="lazy">
        <label>{{ $t('core.auth.field.email') }}</label>
        <i-input
          v-model="form.email"
          type="email"
          name="email"
          :autofocus="true"
          autocomplete="on"
        />
      </z-form-input>
    </z-form-group>

    <z-form-group>
      <z-form-input :rules="{ required: true }" mode="lazy">
        <label>{{ $t('core.auth.field.password') }}</label>
        <i-input v-model="form.password" :type="password_params.type" />
        <icon
          v-if="!!form.password"
          :type="password_params.icon"
          class="password-eye"
          size="20"
          @click="toggle_password"
        />
      </z-form-input>
    </z-form-group>

    <z-form-group>
      <z-form-input>
        <div class="row">
          <div class="col-12">
            <router-link
              class="auth-content__link"
              :to="{ name: 'auth.reset_password', params: { email: form.email } }"
            >
              {{ $t('core.auth.button.recovery_password') }}
            </router-link>
          </div>
        </div>
      </z-form-input>
    </z-form-group>

    <z-form-input>
      <i-button
        html-type="submit"
        class="auth-content__form__submit"
        type="primary"
        :loading="is_loading"
        :disabled="is_button_disabled"
      >
        {{ $t('core.auth.button.sign_in') }}
      </i-button>
    </z-form-input>

    <div class="row mt-4">
      <div class="col-12 text-center b-create_acc">
        {{ $t('core.auth.button.no_acc') }}
        <router-link :to="{ name: 'auth.register' }">
          {{ $t('core.auth.button.sign_up') }}
        </router-link>
      </div>
    </div>
  </z-form>
</template>

<script>
  import { mapActions } from 'vuex';

  // eslint-disable-next-line no-useless-escape
  const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  export default {
    data: () => ({
      form: {
        email: '',
        password: '',
        remember_me: false,
        web: true
      },
      password_params: {
        type: 'password',
        icon: 'md-eye'
      },
      need_show_password: false,
      is_button_disabled: true,
      is_loading: false
    }),

    watch: {
      form: {
        handler: function () {
          const { email, password } = this.form;

          if (!emailRegExp.test(email) || password.length === 0) {
            this.is_button_disabled = true;
          } else {
            this.is_button_disabled = false;
          }

          if (password == '') {
            this.password_params = {
              type: 'password',
              icon: 'md-eye'
            };
          }
        },
        deep: true
      }
    },
    created() {
      if (this.$route.query.email) this.form.email = this.$route.query.email;

      if (!emailRegExp.test(this.form.email) || this.form.password.length === 0) {
        this.is_button_disabled = true;
      } else {
        this.is_button_disabled = false;
      }
    },

    methods: {
      ...mapActions('core/auth', { login: 'login' }),

      sign_in: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_loading = true;
            this.login(this.form)
              .then(() => this.$router.push({ name: 'dashboard' }))
              .catch((e) => this.$noty.error(e.message))
              .finally(() => (this.is_loading = false));
          }
        });
      },

      toggle_password() {
        this.password_params = {
          type: this.password_params.type === 'password' ? 'text' : 'password',
          icon: this.password_params.icon === 'md-eye-off' ? 'md-eye' : 'md-eye-off'
        };
      }
    }
  };
</script>

<style lang="scss">
  .auth-content__link {
    color: #fff;
    font-family: 'Lato', 'sans-serif';
    font-size: 14px;
    line-height: 14px;
    text-align: left;
    text-decoration: underline;
  }

  .b-create_acc {
    color: #fff;
    font-family: 'Lato', 'sans-serif';
    font-size: 14px;
    line-height: 24px;
    text-align: left;

    a {
      color: #fff;
      text-decoration: underline;

      &:hover {
        color: #2196f3;
      }
    }
  }

  .white {
    text-align: center;
    color: #fff;
    font-size: 16px;
  }

  .layout--auth .auth-content {
    max-width: 400px;
  }

  .password-eye {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 37px;
  }

  // .white {
  //   text-align: center;
  //   color: #fff;
  //   font-size: 16px;
  // }
  // .layout--auth .auth-content {
  //   max-width: 530px;
  // }
</style>
